export default "/images/arrow-right.svg?bc676486acc586f32ec18785acb6c76e";